import ApiService from '@/store/api.service';
const state = { pendenciaPagar: {} };
const getters = { pendenciaPagar: state => state.pendenciaPagar };
const mutations = { setPendenciaPagar(state, titulo) { state.pendenciaPagar = titulo; } };
async function consulta(acao, dados, get = false) {
  ApiService.setHeader();
  try {
    const { data } = await (get ? ApiService.get(`paylogosAppFluxo/access/${acao}`) : ApiService.post(`paylogosAppFluxo/access/${acao}`, dados));
    if (data?.resultado === false || data?.erro) throw new Error(data.msg || data.erro || 'Não foi possível consultar os títulos. Entre novamente no aplicativo.');
    return data;
  } catch (e) { throw new Error(e.response?.data?.msg || e.message || 'Não foi possível consultar os títulos.'); }
}
const actions = {
  updatePendenciaPagar({ commit }, titulo) { commit('setPendenciaPagar', titulo); },
  listarFluxos(context, dados) { return consulta('listarFluxos', dados); },
  obterFluxo(context, dados) { return consulta('obterFluxo', dados); },
  pendenciaTotal360dias() { return consulta('pendenciaTotal360dias', null, true); },
  verificaSePagaAnuidade(context, dados) { return consulta('verificaSePagaAnuidade', dados); }
};
export default { state, getters, mutations, actions };
